import Loader from './loader';
import UploadProgress from './upload-progress';

export { UploadProgress };
export default Loader;
